import { render, staticRenderFns } from "./file-component.vue?vue&type=template&id=ad59edcc&scoped=true&"
import script from "./file-component.vue?vue&type=script&lang=ts&"
export * from "./file-component.vue?vue&type=script&lang=ts&"
import style0 from "./file-component.vue?vue&type=style&index=0&id=ad59edcc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad59edcc",
  null
  
)

export default component.exports